import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';
import styled, { useTheme } from 'styled-components';

import Grid from '@components/basics/grid';
import { getWidth } from '@components/styles';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

interface NoResultsProps {
  className?: string;
}

const NoResults: FunctionComponent<NoResultsProps> = ({ className }) => {
  const theme = useTheme();
  return (
    <MotionOpacity className={className || ''}>
      <Grid gap={30}>
        <Typography type="subheader" customFont="semi-bold" align="center">
          <Translate id="CATALOG.SEARCH.NO_RESULTS.TITLE" />
        </Typography>
        <Typography color={theme.colors.tertiary} type="small" align="center">
          <Translate id="CATALOG.SEARCH.NO_RESULTS.TEXT" />
        </Typography>
      </Grid>
    </MotionOpacity>
  );
};

export default styled(NoResults)`
  width: 100%;
  max-width: ${getWidth(10)};
  margin: 80px auto 0;
`;
